import React, { useState } from 'react';
import styled from '@emotion/styled';
import {
    useHistory,
} from "react-router-dom";
import { List, ListItem, ListItemButton, ListItemIcon } from '@mui/material';
import InnerRoutes from './InnerRoutes';
import { clearApiToken, decodeToken, getApiToken } from './toolympus/api/core';
// import { SchemaProvider } from './toolympus/hooks/useSchema';
import { Sidebar, Menu, Routes, getRoutesToRender, AppContentSimple, AppContainerView } from './toolympus/components/frame/new';
import { DefaultUser, LogoutSoonWarning, UserContext } from './toolympus/userContext/UserContext';
import { ClassOutlined, ExitToApp, MenuOutlined } from '@mui/icons-material';
import { useLoginGuard } from './toolympus/hooks/auth/useLoginGuard';
import { LogoSmall } from './components/Common';
import { DictionariesProvider } from './toolympus/hooks/useDictionaries';
import { ThemeSettings } from './theme';
import { UserSettingsProvider } from './toolympus/components/Settings/UserSettingsContext';
import { useMediaBreakpoint } from './toolympus/components/primitives';
import { AppDrawerColored } from './AppDrawerColored';

const AppContent = styled(AppContentSimple)`
  background: #ffffff80;

  & > .MuiPaper-root {
    background: transparent;
  }

  ${props => props.theme.breakpoints.down("sm")} {
    & .project-page-form {
      & .form-header {
        padding-top: 20px;
        flex-flow: row wrap;
        
        & .search-field-wrapper {
          display: none;
        }
  
        & .add-new-button {
          order: 3;
        }
        
        & .curators-selector {
          order: 4;
          flex-flow: row wrap;
  
        }
      }

    }
  }
`;

const MenuButton = styled.button`
  position: fixed;
  bottom: 16px;
  right: 16px;

  width: 32px;
  height: 32px;
  border-radius: 16px;
  border: none;
  outline: none;
  background: ${ThemeSettings.colors.background};
  color: ${ThemeSettings.colors.blue_grey_dark};
  border: 1px solid ${ThemeSettings.colors.blue_grey}40;
  box-shadow: 1px 1px 5px -2px #00000040;

  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  
  
  & .MuiSvgIcon-root {
    color: ${ThemeSettings.colors.blue_grey_dark};
    font-size: 16px;
  }
`;

const AppContainerViewX = styled(AppContainerView)`
  background: linear-gradient(45deg, #869ab720, #b9d1ef20), url(/img/iclrc_ceil_x_2k.png);
  background-size: 100%, cover;

  & .form2-wrapper {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const AppRouter: React.FC = () => {
    const token = getApiToken();
    const history = useHistory();
    const [user, setUser] = useState<DefaultUser>(token ? decodeToken(token) as DefaultUser : { _id: '', roles: [], email: '' });

    const logout = () => {
        clearApiToken();
        history.push('/login');
    }

    useLoginGuard("/login", { isAuthenticated: !!user && user.roles.length > 0 });

    const { routes, menuItems } = getRoutesToRender(InnerRoutes, user);

    const bottom = (
        <List>
            <ListItem button key='logout' onClick={logout}>
              <ListItemIcon><ExitToApp /></ListItemIcon>
            </ListItem>
        </List>
    )

    const isMobile = useMediaBreakpoint("down", "sm");
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
    

    return (
        <UserContext.Provider value={{ user: user, setUser: setUser }}>
          <DictionariesProvider apiPath="/api/settings/dictionaries">
            <LogoutSoonWarning />
              <UserSettingsProvider apiPath="/api/app-settings">
                        <AppContainerViewX disableGutters maxWidth={false}>
                            <Sidebar
                                top={<LogoSmall version={2} />}
                                width={60}
                                menu={<>
                                  <Menu iconsOnly menuItems={menuItems} />
                                  <List>
                                    <ListItemButton href="https://kb.iclrc.ru" title="База знаний" target="_blank" rel="noreferrer noopener">
                                      <ClassOutlined />
                                    </ListItemButton>
                                    <ListItemButton href="https://iclrc.bitrix24.ru" title="Битрикс" target="_blank" rel="noreferrer noopener">
                                      <img className="icon-custom" alt="Б24" src="/img/b24w.svg" />
                                    </ListItemButton>
                                  </List>
                                </>}
                                bottom={bottom}
                                open={!isMobile || isMobileMenuOpen}
                                noMenuButton
                                onClose={() => setIsMobileMenuOpen(false)}
                                drawerPaperComponent={AppDrawerColored}
                            />
                            <AppContent fit100Height>
                                <Routes routes={routes} notFoundRedirect={user?.roles?.includes("admin") ? "/start" : "/start"} />
                            </AppContent>

                            {!!isMobile && !isMobileMenuOpen &&
                              <MenuButton onClick={() => setIsMobileMenuOpen(true)}>
                                <MenuOutlined />
                              </MenuButton>}
                        </AppContainerViewX>
              </UserSettingsProvider>
          </DictionariesProvider>
        </UserContext.Provider>
    );
}

export default AppRouter;

